// components/MapPickerModal.jsx
import React from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    'https://unpkg.com/leaflet@1.9.3/dist/images/marker-icon-2x.png',
  iconUrl:
    'https://unpkg.com/leaflet@1.9.3/dist/images/marker-icon.png',
  shadowUrl:
    'https://unpkg.com/leaflet@1.9.3/dist/images/marker-shadow.png',
});

const LocationMarker = ({ position, setPosition }) => {
  useMapEvents({
    click(e) {
      setPosition(e.latlng);
    },
  });

  return position ? <Marker position={position} /> : null;
};

const MapPickerModal = ({ visible, onClose, onSave, initialPosition }) => {
 const [position, setPosition] = React.useState(null);

React.useEffect(() => {
  if (Array.isArray(initialPosition)) {
    setPosition({ lat: initialPosition[0], lng: initialPosition[1] });
  } else if (initialPosition) {
    setPosition(initialPosition);
  } else {
    setPosition(null);
  }
}, [initialPosition, visible]);
 
  if (!visible) return null;
  return (
    <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5>Select Location</h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <MapContainer
              center={position || [23.0225, 72.5714]} // Default: Ahmedabad
              zoom={13}
              style={{ height: '400px', width: '100%' }}
            >
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              <LocationMarker position={position} setPosition={setPosition} />
            </MapContainer>
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
            <button
              className="btn btn-primary"
              onClick={() => onSave(position)}
              disabled={!position}
            >
              Save Location
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MapPickerModal;
